<template>
  <div>
    <input
      type="tel"
      :id="id"
      :name="name"
      :value="numberValue"
      class="c-input-number"
      :class="{
        'c-input-number--error': error,
        'c-input-number--has_icon': hasIcon,
        'c-input-number--has_suffix': hasSuffix
      }"
      :step="step"
      :min="min"
      :max="max"
      :error="error"
      :placeholder="placeholder"
      @keypress="validateValue"
      @input="updateValue"
    />
    <span v-if="$slots.lastLabel">
      <slot name="lastLabel"></slot>
    </span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Options({
  props: {
    id: { type: String, required: false },
    name: { type: String, required: true },
    value: { type: Number, required: true },
    error: { type: String, required: false },
    placeholder: { type: String, required: false },
    hasIcon: { type: Boolean, required: false },
    hasSuffix: { type: Boolean, required: false },
    step: { type: Number, required: false },
    min: { type: Number, required: false },
    max: { type: Number, required: false }
  }
})

export default class InputNumber extends Vue {

  id!: string;
  name!: string;
  value!: number;
  error!: string;
  placeholder!: string;
  hasIcon!: boolean;
  hasSuffix!: boolean;
  step!: number;
  min!: number;
  max!: number;

  numberValue = this.value;

  updateValue(e: any) {
    const targetValue = e.target.value;
    let replacedValue = "";
    replacedValue = String(targetValue).replace(/[０-９]/g, s =>
      String.fromCharCode(s.charCodeAt(0) - 65248)
    );
    replacedValue = replacedValue.replace(/[^0-9]/g, "");
    this.numberValue = replacedValue ? parseInt(replacedValue, 10) : this.min;
  }
  validateValue(e: any) {
    e = e || window.event;
    let key = e.keyCode || e.which;
    key = String.fromCharCode(key);
    const regex = /[0-9]/;
    if (!regex.test(key)) {
      e.returnValue = false;
      if (e.preventDefault) e.preventDefault();
    }
  }
  changeCount(count: number) {
    this.numberValue = count;
  }

  @Watch("numberValue")
  onNumberValue(newValue: number, oldValue: number) {
    if (newValue <= this.min) {
      this.numberValue = parseInt(this.min.toString(), 10);
    }
    if (newValue >= this.max) {
      this.numberValue = parseInt(this.max.toString(), 10);
    }
    if (newValue <= this.max && newValue >= this.min) {
      this.$emit("input", newValue, oldValue);
    }
  }
}
</script>

<style lang="scss" scoped>
.c-input-number {
  font-size: rem(14);
  line-height: normal;
  width: 100%;
  border: px(1) solid $common-gray-border;
  border-radius: px(4);
  padding: rem(10) rem(12) rem(11) rem(12);
  display: block;

  &--error {
    border-color: $error;
  }

  &--has_icon {
    padding-right: px(48+12);
  }

  &--has_suffix {
    padding-right: px(24+12);
  }

  &::placeholder {
    color: $common-gray300;
  }

  &:focus {
    border-color: $common-black;
  }
}
</style>
